"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var registeredMenu = {};
var menu;
var currentMenuInfo;
function init(element) {
    var elm = element || $("#canvas svg");
    elm.on("contextmenu", function (e) {
        if (typeof currentMenuInfo === "object" && currentMenuInfo != null) {
            e.preventDefault();
            show(currentMenuInfo.type, currentMenuInfo.data, e.pageX, e.pageY);
        }
        else {
            return;
        }
    });
}
exports.init = init;
function register(menuType, content) {
    registeredMenu[menuType] = content;
}
exports.register = register;
function setInfo(info) {
    currentMenuInfo = info;
}
exports.setInfo = setInfo;
function clearInfo() {
    currentMenuInfo = null;
}
exports.clearInfo = clearInfo;
function show(menuType, data, x, y) {
    if (typeof menu === "undefined") {
        findMenu();
    }
    var generator = registeredMenu[menuType];
    if (typeof generator !== "function") {
        console.error("[Context Menu] Undefined generator!");
    }
    menu.empty()
        .addClass("active")
        .offset({ top: y, left: x });
    var menuContent = generator(data);
    if (typeof menuContent === "string") {
        menu.html(menuContent);
    }
    else {
        menu.append(menuContent);
    }
    $("body").one("click", function () {
        menu.removeClass("active");
    });
}
exports.show = show;
function findMenu() {
    menu = $("<div class='bvd3-context-menu-new' />").appendTo("body");
}
function generateMenu(menuDef) {
    var menuElm;
    // menu
    menuElm = $("<ul class=\"bvd3-menu\"></ul>");
    // title
    if (menuDef.title) {
        menuElm.append("<li class=\"bvd3-menu-title\">" + menuDef.title + "</li>");
    }
    if (menuDef.subtitle) {
        menuElm.append("<li class=\"bvd3-menu-subtitle\">" + menuDef.subtitle + "</li>");
    }
    // items
    for (var _i = 0, _a = menuDef.items; _i < _a.length; _i++) {
        var item = _a[_i];
        var itemElm = $("<li class=\"bvd3-menu-item\">" + item.title + "</li>");
        if (item.action) {
            itemElm.on("click", item.action);
        }
        if (item.selected) {
            itemElm.addClass("selected");
        }
        // sub menu
        if (item.subMenu) {
            itemElm.append(generateMenu(item.subMenu));
            itemElm.addClass("with-submenu");
        }
        // builtin menu
        if (item.builtinMenu) {
            itemElm.append(builtinSubmenu(item.builtinMenu));
            itemElm.addClass("with-submenu");
        }
        menuElm.append(itemElm);
    }
    return menuElm;
}
exports.generateMenu = generateMenu;
var DEFAULT_COLORS = ["#00c6ff", "#ffbb4d", "#ff4d4d", "#4dffa9", "#66c", "#6c6", "#c66"];
function builtinSubmenu(def) {
    var menuElm = $("<ul class=\"bvd3-menu\"></ul>");
    if (def.name === "color") {
        var colorList = def.colorList || DEFAULT_COLORS;
        var menuItemElm_1 = $("<li class=\"bvd3-menu-item custom\"></li>");
        colorList.forEach(function (color) {
            var colorDiv = $("<div class=\"color-choose\" data-color=\"" + color + "\" style=\"background:" + color + "\"></div>");
            colorDiv.on("click", function (e) {
                def.callback.call(def, $(e.target).data("color"));
            });
            menuItemElm_1.append(colorDiv);
        });
        menuElm.append(menuItemElm_1);
        var customMenuItemElm = $("<li class=\"bvd3-menu-item custom\">Custom\u2026\u2026</li>");
        menuElm.append(customMenuItemElm);
    }
    else if (def.name === "option-list") {
        def.options.forEach(function (opt) {
            var menuItemElm = $("<li class=\"bvd3-menu-item\">" + opt.title + "</li>");
            menuItemElm.data("optdata", opt.data);
            menuItemElm.on("click", function (e) {
                def.callback.call(def, $(e.target).data("optdata"));
            });
            menuElm.append(menuItemElm);
        });
    }
    return menuElm;
}
//# sourceMappingURL=context-menu.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/ui/context-menu.js
// module id = 874
// module chunks = 0 1